import React from 'react'
import { Document, Page, StyleSheet, View, Text, Image } from "@react-pdf/renderer";
import getLogo from './getLogo'

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    fontSize: '10pt',
    padding: '2cm',
    textAlign: 'justify'
  },
  logo: {
    width: 50,
    height: 50,
  },
  title:{
    fontSize: '14pt',
  },
  main:{
    border: '1px solid black',
    borderRadius: 8,
    backgroundColor: '#eeeeee',
    padding: 12,
  },
  obs: {
    color: 'gray',
    fontSize: '9pt',
    lineHeight: '1.5pt',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    maxWidth: '100%',
    marginBottom: 4,
  },
  content:{
    lineHeight: '1.8pt',
  },
  field: {
    fontSize: '11pt',
    color: 'darkblue',
  },
  center:{
    textAlign: 'center',
  }
});

const leePdf = ({ nome, cpf, procedimentos, cidade, estado, data,
                   nomeExibicao, crm, risk, groupName, logoName}) => (

<Document title="APA" author={nome} creator="www.avaliacaopreanestesica.com">
  <Page style={styles.page} wrap={false}>
    <View style={styles.row}>
        <View><Image style={styles.logo} src={getLogo(logoName)}/></View>
        <View style={styles.center}>
          <Text style={styles.title}>Índice de Risco Cardíaco Revisado Lee</Text>
        </View>
    </View>
    <View>
      <Text style={styles.content}> NOME: <Text style={styles.field}> {nome} </Text></Text>
      <Text style={styles.content}>PROCEDIMENTO(S): {"\n"}<Text style={styles.field}> {procedimentos} </Text></Text>
    </View>
    <View>
        {risk === 0 &&
          <Text style={styles.main}>
            <Text style={styles.content}>- Não foi identificada nenhuma variável de Lee{"\n"}</Text>
            <Text style={styles.content}>- Nesse caso, o risco de complicações cardíacas maiores é de <Text style={styles.field}> 0,4</Text>%{"\n"}</Text>
            <Text style={styles.content}>Complicações cardíacas maiores incluem: infarto do miocárdio, edema pulmonar, fibrilação ventricular ou parada cardíaca primária e bloqueio
            cardíaco completo até o 5o dia pós-operatório.{"\n"}</Text>
          </Text>
        }
        {risk === 1 &&
          <Text style={styles.main}>
            <Text style={styles.content}>- Foi identificada <Text style={styles.field}> 1 </Text> variável de Lee{"\n"}</Text>
            <Text style={styles.content}>- Nesse caso, o risco de complicações cardíacas maiores é de <Text style={styles.field}> 0,9</Text>%{"\n"}</Text>
            <Text style={styles.content}>Complicações cardíacas maiores incluem: infarto do miocárdio, edema pulmonar, fibrilação ventricular ou parada cardíaca primária e bloqueio
            cardíaco completo até o 5o dia pós-operatório.{"\n"}</Text>
          </Text>
        }
        {risk === 2 &&
          <Text style={styles.main}>
            <Text style={styles.content}>- Foram identificadas <Text style={styles.field}> 2 </Text> variáveis de Lee{"\n"}</Text>
            <Text style={styles.content}>- Nesse caso, o risco de complicações cardíacas maiores é de <Text style={styles.field}> 6,6</Text>%{"\n"}</Text>
            <Text style={styles.content}>Complicações cardíacas maiores incluem: infarto do miocárdio, edema pulmonar, fibrilação ventricular ou parada cardíaca primária e bloqueio
            cardíaco completo até o 5o dia pós-operatório.{"\n"}</Text>
          </Text>
        }
        {risk > 2 &&
          <Text style={styles.main}>
            <Text style={styles.content}>- Foram identificadas <Text style={styles.field}> 3 </Text>ou mais variáveis de Lee{"\n"}</Text>
            <Text style={styles.content}>- Nesse caso, o risco de complicações cardíacas maiores é de <Text style={styles.field}> 11</Text>%{"\n"}</Text>
            <Text style={styles.content}>Complicações cardíacas maiores incluem: infarto do miocárdio, edema pulmonar, fibrilação ventricular ou parada cardíaca primária e bloqueio
            cardíaco completo até o 5o dia pós-operatório.{"\n"}</Text>
          </Text>
        }

    </View>
    <View>
      <Text style={styles.content}>
      Sobre o IRCR de Lee:{"\n"}
      - O IRCR foi proposto por Lee et al., em 1999, em um estudo realizado na Califórnia, EUA.
      Este escore compreende uma revisão do Índice proposto por Goldman em 1977.
      No IRCR, os pacientes são divididos em quatro classes de risco, compostas a partir de
      seis variáveis: cirurgia de alto risco, história de doença isquêmica cardíaca,
      história de insuficiência cardíaca congestiva, história de doença cerebrovascular,
      diabetes insulino-dependente e creatinina sérica maior que 2,0 mg/dL. As classes I, II, III e IV
      são divididas a partir da somatória dessas variáveis apresentadas pelo paciente,
      totalizando 0, 1, 2 ou ≥ 3, respectivamente. Esta nova revisão foi derivada e validada
      a partir de uma investigação prospectiva com 4315 pacientes, a qual demonstrou que
      este é um índice simples, de fácil aplicação e com boa capacidade para predição
      do risco de complicações cardíacas em cirurgia não cardíaca eletiva de grande porte,
      sobretudo quando comparado com outros índices.{"\n"}
      </Text>
    </View>
    <View>
      <Text style={styles.obs}>
      Todas as informações aqui contidas têm caráter apenas informativo.{"\n"}
      Quaisquer condutas médicas devem ser decididas pelo médico assistente
      juntamente com o paciente, respeitando os quatro princípios bioéticos
      fundamentais, quais sejam: autonomia, beneficência, não-maleficência e justiça.
      </Text>
      <Text style={styles.obs}>
      {"\n"}Fontes:{"\n"}
      - Lee TH et al. Derivation and prospective validation of a simple index for prediction of cardiac risk of major noncardiac surgery. Circulation. 1999{"\n"}
      - Loureiro B. Perioperative risk scores for non-cardiac surgery: descriptions and comparisons. 2014{"\n"}
      - Gualandro DM et al. 3a Diretriz de Avaliação Cardiovascular Perioperatória da Sociedade Brasileira de Cardiologia. 2017
      </Text>
    </View>
    <View style={styles.center}>
      <Text>
        ______________________________________________________________
      </Text>
      <Text>
        ASSINATURA DO MÉDICO ANESTESIOLOGISTA
      </Text>
      <Text>
        {groupName ? groupName : (nomeExibicao ? nomeExibicao : 'www.avaliacaopreanestesica.com')}
        {!groupName && crm && ` CRM: ${crm}`}
      </Text>
    </View>
    <View style={styles.center}>
      <Text style={styles.data}>
        {cidade && `${cidade}/${estado},`} {data.toLocaleDateString()}
      </Text>
    </View>
  </Page>
</Document>
);

export default leePdf
